// src/belediye/components/notifications/KurulumRehberi.js
//
// FAZ-102 — ADIM ADIM KURULUM REHBERİ
//
// Kullanıcı (2026-08-02): "kullanıcı uygulamaya veya tarayıcıya girince nerede
// nasıl tıklayacak, yönlendirelim, adım adım ilerlemesini sağla."
//
// ════════════════════════════════════════════════════════════════════════════
// NEDEN VAR: FAZ-84'te yapılan rehber PASİFTİ — zile bas, Ayarlar'a gir, aşağı
// kaydır. Kimse oraya girmiyor, kimse kurmuyordu. Veritabanı bunu birebir
// doğruluyordu: gerçek bir telefondan TEK abonelik yok. Altyapı çalışıyor ama
// kimse kapıdan girmiyorsa, altyapı çalışmıyor demektir.
//
// TEMEL İLKE: EKRANDA AYNI ANDA TEK BİR İŞ OLUR.
// Bir kutuya dört adımı birden yazmak "anlatmak" değildir; kişi hangisinde
// olduğunu kaybeder. Bu yüzden her ekranda tek adım, tek düğme, tek cümle var
// ve nerede duracağı elle gösteriliyor (üstteki ok + simge).
//
// KENDİLİĞİNDEN İLERLER: rehber kişinin nerede olduğunu ölçer, tahmin etmez.
// iPhone'da kişi ana ekrana ekleyince Safari'den çıkar; simgeden geri girdiğinde
// aşama "izin-yok"a döner ve rehber DOĞRUDAN izin adımından açılır — kişi
// baştan başlamaz. Android'de kurulum penceresi kapanınca aynı ekranda ilerler.
//
// NE ZAMAN / KAÇ KEZ: kurulumRehberiZaman.js (üç kez, 3 ve 10 gün aralıklarla,
// "bir daha sorma" kalıcı, aşama değişince haklar yenilenir).
// ════════════════════════════════════════════════════════════════════════════
import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  durumOku,
  kurulumBaslat,
  kurulumDinle,
  kurulumPenceresiVar,
  pushAc,
} from "../../services/pushIstemci";
import {
  asamaBelirle,
  birDahaSorma,
  ertele,
  gosterildiIsaretle,
  temizle,
} from "../../services/kurulumRehberiZaman";
import "./KurulumRehberi.css";

// ── Simgeler ────────────────────────────────────────────────────────────────
// Ekran görüntüsü YERİNE çizim: görüntü, telefonun sürümü değişince yalan
// söyler ve kimse fark etmez. Çizim, "şu şekilli düğme" demenin en dayanıklı
// hâli — hem de tek bayt ağ isteği doğurmaz.

function PaylasSimge() {
  // iOS Paylaş: kutudan yukarı çıkan ok.
  return (
    <svg viewBox="0 0 24 24" className="kr-simge" aria-hidden="true">
      <path
        d="M12 3l4 4M12 3L8 7M12 3v12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11H5a1 1 0 00-1 1v8a1 1 0 001 1h14a1 1 0 001-1v-8a1 1 0 00-1-1h-1"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function AnaEkranSimge() {
  return (
    <svg viewBox="0 0 24 24" className="kr-simge" aria-hidden="true">
      <rect
        x="4"
        y="3"
        width="16"
        height="18"
        rx="3"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M12 8v8M8 12h8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MenuSimge() {
  // Android Chrome: sağ üstteki üç nokta.
  return (
    <svg viewBox="0 0 24 24" className="kr-simge" aria-hidden="true">
      <circle cx="12" cy="5" r="1.7" fill="currentColor" />
      <circle cx="12" cy="12" r="1.7" fill="currentColor" />
      <circle cx="12" cy="19" r="1.7" fill="currentColor" />
    </svg>
  );
}

function ZilSimge() {
  return (
    <svg viewBox="0 0 24 24" className="kr-simge" aria-hidden="true">
      <path
        d="M18 16v-5a6 6 0 10-12 0v5l-1.5 2h15L18 16z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M10 21a2 2 0 004 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

// ── Adım listeleri ──────────────────────────────────────────────────────────
//
// `yon` = ekranda o düğmenin NEREDE olduğunu söyleyen ok. "Paylaş düğmesine
// dokunun" tek başına eksik bir tariftir; iPhone'da o düğme ALTTA, Android'de
// ÜSTTE. Yanlış yeri tarif eden bir rehber, hiç rehber olmamasından kötüdür.

const IOS_ADIMLAR = [
  {
    simge: <PaylasSimge />,
    yon: "asagi",
    baslik: "Ekranın alt kısmındaki Paylaş düğmesine dokunun",
    metin: "Safari’nin alt çubuğunda yer alan, yukarı ok simgeli düğmedir.",
  },
  {
    simge: <AnaEkranSimge />,
    yon: null,
    baslik: "“Ana Ekrana Ekle” seçeneğini işaretleyin",
    metin: "Açılan listeyi yukarı doğru kaydırınız; seçenek listenin alt bölümündedir.",
  },
  {
    simge: <AnaEkranSimge />,
    yon: "yukari",
    baslik: "Sağ üst köşedeki “Ekle” düğmesine dokunun",
    metin: "Uygulama, cihazınızın ana ekranına eklenecektir.",
  },
  {
    simge: <ZilSimge />,
    yon: null,
    baslik: "Ana ekrandaki simgeden uygulamaya giriş yapın",
    metin:
      "Bu adım zorunludur: iOS, tarayıcı sekmesinde açık duran bir adrese bildirim iletmez.",
  },
];

// Android'de kurulum ZORUNLU DEĞİLDİR (bildirim sekmede de çalışır); bu liste
// yalnız "simge de isterim" diyene, kurulum penceresi açılamadığında gösterilir.
const ANDROID_ELLE_ADIMLAR = [
  {
    simge: <MenuSimge />,
    yon: "yukari",
    baslik: "Sağ üst köşedeki ⋮ menüsüne dokunun",
    metin: "Chrome adres çubuğunun sağında yer alan üç nokta simgesidir.",
  },
  {
    simge: <AnaEkranSimge />,
    yon: null,
    baslik: "“Uygulamayı yükle” seçeneğini işaretleyin",
    metin: "Bazı cihazlarda “Ana ekrana ekle” olarak görünür; aynı işlemdir.",
  },
];

export default function KurulumRehberi({ userId, asama: ilkAsama, onKapat }) {
  const [durum, setDurum] = useState(null);
  const [adim, setAdim] = useState(0);
  const [islemde, setIslemde] = useState(false);
  const [hata, setHata] = useState("");
  const [kurulabilir, setKurulabilir] = useState(kurulumPenceresiVar());
  const [bitti, setBitti] = useState(false);

  const tazele = useCallback(async () => {
    try {
      setDurum(await durumOku());
    } catch (_) {
      /* rehber, ölçüm hatası yüzünden kapanmaz */
    }
  }, []);

  useEffect(() => {
    tazele();
    gosterildiIsaretle({ userId, asama: ilkAsama });
  }, [tazele, userId, ilkAsama]);

  // Kurulabilirlik sonradan doğabilir (Chrome olayı geç gönderir).
  useEffect(() => kurulumDinle(setKurulabilir), []);

  // Kişi telefon ayarlarına gidip dönmüş olabilir; sekmeye her dönüşte yeniden
  // ölçülür. Tahmin yerine ölçüm — rehber kişinin gerçekten nerede olduğunu
  // bilmeden doğru adımı gösteremez.
  useEffect(() => {
    const bak = () => {
      if (!document.hidden) tazele();
    };
    document.addEventListener("visibilitychange", bak);
    window.addEventListener("focus", bak);
    return () => {
      document.removeEventListener("visibilitychange", bak);
      window.removeEventListener("focus", bak);
    };
  }, [tazele]);

  const asama = useMemo(() => {
    if (!durum) return ilkAsama;
    return asamaBelirle(durum);
  }, [durum, ilkAsama]);

  // Abone olundu → rehberin işi bitti.
  useEffect(() => {
    if (asama === "tamam" && !bitti) {
      setBitti(true);
      temizle({ userId });
    }
  }, [asama, bitti, userId]);

  const ios = durum ? durum.platform === "ios" : false;
  const android = durum ? durum.platform === "android" : false;

  // Zorunlu çok adımlı anlatım YALNIZ iPhone'a aittir (aşama "kurulmamis"
  // yalnız orada doğar). Android'de kurulum isteğe bağlıdır ve izin verildikten
  // SONRA teklif edilir — bkz. "simge teklifi".
  const adimlar = asama === "kurulmamis" && ios ? IOS_ADIMLAR : [];

  // Simge teklifi: iş bittikten sonra, telefonda ve henüz kurulu değilse.
  // Bildirimin şartı DEĞİLDİR; simge ve okunmamış rozeti için güzeldir.
  const simgeTeklifi = Boolean(durum && android && !durum.standalone);
  const [simgeReddedildi, setSimgeReddedildi] = useState(false);
  // Kurulum penceresi açılamazsa elle tarife düşülür — "bastım ama bir şey
  // olmadı" ekranı bırakılmaz.
  const [simgeElle, setSimgeElle] = useState(false);
  const [simgeAdim, setSimgeAdim] = useState(0);

  const kur = async () => {
    setIslemde(true);
    setHata("");
    const sonuc = await kurulumBaslat();
    setIslemde(false);
    if (sonuc === "kuruldu") {
      tazele();
    } else if (sonuc === "yok") {
      setKurulabilir(false);
      setSimgeElle(true);
    } else {
      // Vazgeçti — simge zaten isteğe bağlıydı, ısrar edilmez.
      setSimgeReddedildi(true);
    }
  };

  const izinVer = async () => {
    setIslemde(true);
    setHata("");
    const sonuc = await pushAc();
    setIslemde(false);
    if (!sonuc.ok) setHata(sonuc.hata);
    tazele();
  };

  const simdiDegil = () => {
    ertele({ userId });
    onKapat();
  };

  const sorma = () => {
    birDahaSorma({ userId });
    onKapat();
  };

  // ── Gövde ────────────────────────────────────────────────────────────────
  let govde;

  if ((bitti || asama === "tamam") && simgeTeklifi && !simgeReddedildi && simgeElle) {
    // ── Kurulum penceresi açılamadı → elle tarif (yine isteğe bağlı) ────────
    const a = ANDROID_ELLE_ADIMLAR[Math.min(simgeAdim, ANDROID_ELLE_ADIMLAR.length - 1)];
    govde = (
      <>
        <div className="kr-sayac">
          İsteğe bağlı · {simgeAdim + 1} / {ANDROID_ELLE_ADIMLAR.length}
        </div>
        {a.yon ? <div className={`kr-ok kr-ok-${a.yon}`} aria-hidden="true" /> : null}
        <div className="kr-simge-kap">{a.simge}</div>
        <h3 className="kr-baslik">{a.baslik}</h3>
        <p className="kr-metin">{a.metin}</p>
        <div className="kr-adim-dugmeler">
          <button type="button" className="btn-md kr-geri" onClick={onKapat}>
            Vazgeç
          </button>
          {simgeAdim < ANDROID_ELLE_ADIMLAR.length - 1 ? (
            <button
              type="button"
              className="btn-md btn-md-primary kr-birincil"
              onClick={() => setSimgeAdim(simgeAdim + 1)}
            >
              Devam
            </button>
          ) : (
            <button type="button" className="btn-md btn-md-primary kr-birincil" onClick={onKapat}>
              Tamam
            </button>
          )}
        </div>
      </>
    );
  } else if ((bitti || asama === "tamam") && simgeTeklifi && !simgeReddedildi && kurulabilir) {
    // ── İŞ BİTTİ + İSTEĞE BAĞLI SİMGE TEKLİFİ (yalnız Android) ──────────────
    //
    // Android'de bildirim ZATEN çalışıyor; bu ekran bir şart değil, bir ikram.
    // Bu yüzden ikinci düğme eşit ağırlıkta: "Gerekmiyor" da tam bir cevaptır.
    govde = (
      <>
        <div className="kr-tik" aria-hidden="true">✓</div>
        <h3 className="kr-baslik">Bildirimler etkinleştirildi</h3>
        <p className="kr-metin">
          Dilerseniz uygulamayı <b>ana ekranınıza ekleyebilirsiniz</b>. Bu durumda
          uygulama simgeden doğrudan açılır ve simge üzerinde okunmamış bildirim
          sayınız görüntülenir. Bildirimlerin çalışması için gerekli değildir.
        </p>
        <div className="kr-adim-dugmeler">
          <button type="button" className="btn-md kr-geri" onClick={onKapat}>
            Gerekmiyor
          </button>
          <button
            type="button"
            className="btn-md btn-md-primary kr-birincil"
            onClick={kur}
            disabled={islemde}
          >
            Ana ekrana ekle
          </button>
        </div>
      </>
    );
  } else if (bitti || asama === "tamam") {
    govde = (
      <div className="kr-bitti">
        <div className="kr-tik" aria-hidden="true">
          ✓
        </div>
        <h3 className="kr-baslik">İşlem tamamlandı</h3>
        <p className="kr-metin">
          Size talep atandığında, onayınız beklendiğinde ve yeni mesaj ulaştığında
          <b>cihazınıza bildirim iletilecektir</b>.
        </p>
        <button type="button" className="btn-md btn-md-primary kr-birincil" onClick={onKapat}>
          Kapat
        </button>
      </div>
    );
  } else if (asama === "kurulmamis" && adimlar.length) {
    // ── Çok adımlı anlatım (iPhone · elle Android) ──
    const a = adimlar[Math.min(adim, adimlar.length - 1)];
    govde = (
      <>
        <div className="kr-sayac">
          Adım {adim + 1} / {adimlar.length}
        </div>
        {a.yon ? <div className={`kr-ok kr-ok-${a.yon}`} aria-hidden="true" /> : null}
        <div className="kr-simge-kap">{a.simge}</div>
        <h3 className="kr-baslik">{a.baslik}</h3>
        <p className="kr-metin">{a.metin}</p>

        {durum && durum.iosBaskaTarayici ? (
          <p className="kr-uyari">
            Bu işlem iOS cihazlarda <b>yalnızca Safari</b> tarayıcısıyla yapılabilir.
            Lütfen bu sayfayı Safari ile açınız.
          </p>
        ) : null}

        <div className="kr-adim-dugmeler">
          {adim > 0 ? (
            <button type="button" className="btn-md kr-geri" onClick={() => setAdim(adim - 1)}>
              Geri
            </button>
          ) : null}
          {adim < adimlar.length - 1 ? (
            <button
              type="button"
              className="btn-md btn-md-primary kr-birincil"
              onClick={() => setAdim(adim + 1)}
            >
              Devam
            </button>
          ) : (
            <button type="button" className="btn-md btn-md-primary kr-birincil" onClick={onKapat}>
              Uygulamaya geçiyorum
            </button>
          )}
        </div>
      </>
    );
  } else if (durum && durum.izin === "denied") {
    // ── İzin reddedilmiş: tarayıcı bir daha soramaz ──
    govde = (
      <>
        <div className="kr-simge-kap">
          <ZilSimge />
        </div>
        <h3 className="kr-baslik">Bildirim izni verilmemiş</h3>
        <p className="kr-metin">
          İzin daha önce reddedildiğinden tarayıcı yeniden talep edememektedir.
          Cihaz ayarlarından etkinleştirmeniz gerekmektedir:
        </p>
        <p className="kr-yol">
          {ios
            ? "Ayarlar → Bildirimler → Arsuz Çözüm Merkezi → İzin Ver"
            : "Ayarlar → Uygulamalar → Arsuz Çözüm Merkezi → Bildirimler → Aç"}
        </p>
        <button type="button" className="btn-md btn-md-primary kr-birincil" onClick={tazele}>
          Etkinleştirdim, kontrol et
        </button>
      </>
    );
  } else {
    // ── İzin adımı (tek dokunuş) ──
    govde = (
      <>
        <div className="kr-simge-kap">
          <ZilSimge />
        </div>
        <h3 className="kr-baslik">
          {ios ? "Son adım: bildirim izni" : "Telefon bildirimlerini etkinleştirin"}
        </h3>
        {/* FAZ-104 — kullanıcı (2026-08-02): "izinler kısmında konum izni gibi
            bir ibare var; bunu ben sana anlatım olsun diye söylemiştim.
            Rehberdeki yazıları daha resmî, kurumsal bir dille düzenle."

            Benzetme kaldırıldı. Kurum içi bir uygulamada, personelin başka bir
            özelliğe atıfla yönlendirilmesi hem gereksiz hem de o özelliği
            kullanmamış kişide anlamsız. Söylenmesi gereken tek şey, birazdan
            ne olacağıdır — çünkü beklenmedik izin penceresi, reddedilmenin en
            yaygın sebebidir. */}
        <p className="kr-metin">
          Aşağıdaki düğmeye dokunduğunuzda cihazınız bildirim izni isteyecektir.
          Açılan pencerede <b>“İzin Ver”</b> seçeneğini onaylamanız yeterlidir.
          {android ? " Uygulamayı kurmanız gerekmez." : ""}
        </p>
        <button
          type="button"
          className="btn-md btn-md-primary kr-birincil"
          onClick={izinVer}
          disabled={islemde}
        >
          {islemde ? "Lütfen bekleyiniz…" : "Bildirimlere izin ver"}
        </button>
        {hata ? <p className="kr-hata">{hata}</p> : null}
      </>
    );
  }

  return (
    <div className="kr-katman" role="dialog" aria-modal="true" aria-label="Telefon bildirimi kurulumu">
      {/* Zemine dokunmak kapatmaz: kişi bir adımın ortasındayken kazara
          kapanması, baştan başlaması demek olurdu. Kapatma yolları açık ve
          yazılı (aşağıdaki iki bağlantı + üstteki ×). */}
      <div className="kr-kart">
        <button type="button" className="kr-kapat" onClick={simdiDegil} aria-label="Kapat">
          ×
        </button>

        <div className="kr-ust">Telefon bildirimleri</div>
        {govde}

        {!bitti && asama !== "tamam" ? (
          <div className="kr-alt">
            <button type="button" className="kr-link" onClick={simdiDegil}>
              Daha sonra
            </button>
            <span className="kr-ayrac">·</span>
            <button type="button" className="kr-link kr-link-soluk" onClick={sorma}>
              Bir daha hatırlatma
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
